module.exports = emotion;